import { styled } from '@mui/material/styles';
const Img = styled('img')({});
export default Img;
